import { ButtonLink } from "@/components/lib/ButtonLink";
import { Row, Col } from "react-bootstrap";
import { BookingSlotListTable } from "@/components/entities/booking_slot/BookingSlotListTable";
import { useUserRole } from "@/hooks/useUserRole";
import { useOutletContext } from "react-router-dom";
import React from "react";

type ContextType = {
  setTitle: React.Dispatch<React.SetStateAction<string>>
}

export const BookingSlotList = () => {
   const { setTitle } = useOutletContext<ContextType>()
    const myRole = useUserRole();
  
    React.useEffect(() => {
      setTitle('Réservations')
    }, [setTitle])
  
  /* Render
   *******************************************************************************************/
  return (
    <>
      <Row>
        <Col>
          {myRole === import.meta.env.VITE_APP_ROLE_SUPER_ADMIN && (
            <ButtonLink
              name={"Nouvelle réservation"}
              href={"/bookings/creation"}
              icon={"Plus"}
            />
          )}
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <BookingSlotListTable />
        </Col>
      </Row>
    </>
  );
};
